<template>
        <b-button  class='card-challenges-event' @click.prevent="updateInfo">
          <b-card header-tag="header" footer-tag="footer">


            <template v-slot:header class="d-flex">
              <div class="title">
              <h5>
                <PuSkeleton :loading="isLoading" :count="1" width='120px' height="20px">
                  {{title}}
                </PuSkeleton>
              </h5>
              </div>
              <i class="fal fa-edit"></i>
            </template>



            <b-card-text>
              <div class="left">

                <div class="top">
                  <PuSkeleton :loading="isLoading" :count="1" width="200px">
                    <span>
                      <i class="far fa-calendar-alt"></i>
                      <div class="title">{{content.labelStart}}</div>
                    </span>
                    <div class="date">{{ startDate | moment(true) }}</div>
                  </PuSkeleton>
                </div>


                <div class="bottom">
                  <PuSkeleton :loading="isLoading" :count="1" width="200px">
                    <span>
                      <i class="far fa-calendar-alt"></i>
                      <div class="title">{{content.labelEnd}}</div>
                    </span>
                    <div class="date">{{ endDate | moment(true) }}</div>
                  </PuSkeleton>
                </div>

              </div>

              <div class="right">
                <PuSkeleton :loading="isLoading" :count="1" width="120px">
                  <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                  <div class="cible">
                    <p class="title">Objectif</p>
                    <div class="number">{{objectiveNumber}}</div>
                  </div>
                </PuSkeleton>
              </div>

            </b-card-text>



              <div class="line">
                <p class="inprogress">
                  <PuSkeleton :loading="isLoading" :count="1" width="120px">
                    {{inprogress}}
                  </PuSkeleton>
                </p>
                <PuSkeleton :loading="isLoading" :count="1">
                  <b-progress height="0.5625rem" :value="progress(objectiveNumber,inprogress)"
                              :class="isPositive()">
                  </b-progress>
                </PuSkeleton>
              </div>

            <template v-slot:footer>
              <div class="deadline" :class="isDone()">
                <PuSkeleton :loading="isLoading" :count="1" width="100px" height="25px">
                  {{content.dayOf}}{{deadline}}
                </PuSkeleton>
              </div>
              <div class="state" :class="isDone()">
                <PuSkeleton :loading="isLoading" :count="1" width="100px" height="25px">
                  <span v-if="state === 'progress'">EN cours</span>
                  <span v-else-if="state === 'done'">Terminé</span>
                </PuSkeleton>
              </div>
            </template>

          </b-card>
        </b-button>

</template>


<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

moment.locale('fr');
//
export default {
  name: "CardChallengesDate",
  components:{
  },
  props:{
    id:{
      type:String,
    },
    title:{
      type:String,
      default:'Pura Vida'
    },
    objectiveNumber:{
      default:110000
    },
    startDate:{
      type:String,
      default:'04/04/2020'
    },
    endDate:{
      type:String,
      default:'04/05/2020'
    },
    inprogress:{
      default:56000
    },
    // deadline:{
    //   type:String,
    //   default:'45'
    // },
    state:{
      type:String,
      default:'en cours'
    },
    isLoad:{
      type:Boolean,
      default: true
    },    
  },
  data(){
    return {  
      content:{},   
      isLoading:true,
      deadline:0,
    }
  },
  computed: {
    ...mapGetters([
      'getGeneral',
    ]),
  },
  created (){
    this.content = this.getGeneral;
    this.isLoading = this.isLoad;  
    //
    //const start = moment(this.startDate).format('L');
    const end = moment(this.endDate);
    const now = moment();
    this.deadline = end.diff(now, 'days') + 1 < 0 ? 0 : end.diff(now, 'days') + 1;
  },
  mounted() {
    const end = moment(this.endDate);
    const now = moment();
    this.deadline = end.diff(now, 'days') + 1 < 0 ? 0 : end.diff(now, 'days') + 1;
  },
  updated(){
    const end = moment(this.endDate);
    const now = moment();
    this.deadline = end.diff(now, 'days') + 1 < 0 ? 0 : end.diff(now, 'days') + 1;
  },
  methods:{
    moment: function (date,year) {
      return moment(date,year);
    },
    isPositive: function(){
      if (this.deadline === 0){
        if (this.objectiveNumber > this.inprogress){
          return 'negative';
        } else {
          return 'done';
        }
      } else {
        if (this.objectiveNumber > this.inprogress){
          return 'positive';
        } else {
          return 'done';
        }
      }
    },
    isDone: function(){
      if (this.state === 'done'){
        return 'done'
      } else {
        return 'pending';
      }
    },
    getDaysDiff: function (start_date, end_date, date_format = 'YYYY-MM-DD') {
      const getDateAsArray = (date) => {
        return moment(date.split(/\D+/), date_format);
      }
      return getDateAsArray(end_date).diff(getDateAsArray(start_date), 'days') + 1;
    },
    progress : function(target,current){
      let result;
      result = Math.round((current/target)*100);
      return result;
    },
    updateInfo : function(){
      // console.log('UPDATE INFO');
      this.$store.dispatch('setChallengeUpdated',this.id);
      this.$root.$emit('bv::show::modal', 'form-challenge', '#btnShow');
    }
  },
  filters: {
    moment: function (date,year) {
      let $format = !year ? 'Do MMMM': 'Do/MM/YYYY';
      return moment(date).format($format);
    }
  },
  watch : {
    'isLoad' : function (){
      this.isLoading = this.isLoad;    
    },
  },       
}
</script>
